export default "__VITE_ASSET__UtyCYcxn__"